import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 rounded-t-3xl mx-4 md:mx-6">
      <div className="px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-6 whitespace-nowrap cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-fire-line text-accent-500 text-2xl"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-50">
                51fun吃瓜
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              24小时不间断吃瓜黑料，追踪网红翻车、明星八卦、娱乐圈大事件。海量黑料资源，热点全覆盖。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-label text-foreground-100 text-sm font-semibold mb-5">快速导航</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-foreground-400 text-sm hover:text-accent-500 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-400 text-sm hover:text-accent-500 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
              </li>
              <li>
                <a href="#" className="text-foreground-400 text-sm hover:text-accent-500 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
              </li>
              <li>
                <a href="#" className="text-foreground-400 text-sm hover:text-accent-500 transition-colors whitespace-nowrap cursor-pointer">用户协议</a>
              </li>
              <li>
                <a href="#" className="text-foreground-400 text-sm hover:text-accent-500 transition-colors whitespace-nowrap cursor-pointer">免责声明</a>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="font-label text-foreground-100 text-sm font-semibold mb-5">吃瓜分类</h3>
            <ul className="space-y-3">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-foreground-400 text-sm hover:text-accent-500 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <div className="w-4 h-4 inline-flex items-center justify-center mr-1.5">
                      <i className={`${cat.icon} text-xs`}></i>
                    </div>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Social + Contact */}
          <div>
            <h3 className="font-label text-foreground-100 text-sm font-semibold mb-5">关注我们</h3>
            <div className="flex items-center gap-3 mb-6">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-accent-500 transition-colors cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center text-foreground-300">
                  <i className="ri-weibo-line"></i>
                </div>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-accent-500 transition-colors cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center text-foreground-300">
                  <i className="ri-wechat-line"></i>
                </div>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-accent-500 transition-colors cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center text-foreground-300">
                  <i className="ri-tiktok-line"></i>
                </div>
              </a>
            </div>
            <p className="text-foreground-400 text-sm mb-4">
              有猛料？联系我们爆料，保护爆料人隐私。
            </p>
            <a href="mailto:hello@oheaven.cn" className="text-accent-500 text-sm hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">
              hello@oheaven.cn
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-foreground-800/50 px-4 md:px-6 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; 2026 51fun吃瓜黑料不打烊 - 本站内容仅供娱乐，请勿过度解读
          </p>
          <p className="text-foreground-600 text-xs">
            黑料吃瓜 | 51fun吃瓜黑料不打烊 | 吃瓜黑料在线吃瓜
          </p>
        </div>
      </div>

      {/* Background watermark */}
      <div className="relative overflow-hidden rounded-b-3xl h-16 -mt-16 pointer-events-none">
        <span className="absolute bottom-0 left-0 text-[120px] font-heading font-bold text-foreground-800/5 whitespace-nowrap leading-none">
          51FUN
        </span>
      </div>
    </footer>
  );
}